import Button from "../Button";
import React, { useState, useEffect } from 'react';


const AttributeForm = ({ attribute, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    unit: '',
    type: 'text',
    has_predefined_values: false,
    predefined_values: []
  });
  const [newValue, setNewValue] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (attribute) {
      setFormData({
        name: attribute.name || '',
        description: attribute.description || '',
        unit: attribute.unit || '',
        type: attribute.type || 'text',
        has_predefined_values: attribute.has_predefined_values || false,
        predefined_values: attribute.predefined_values || []
      });
    }
  }, [attribute]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));

    // پاک کردن خطا هنگام تغییر
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleAddValue = () => {
    if (newValue.trim() && !formData.predefined_values.some(v => v.value === newValue.trim())) {
      setFormData(prev => ({
        ...prev,
        predefined_values: [...prev.predefined_values, { value: newValue.trim() }]
      }));
      setNewValue('');
    }
  };

  const handleRemoveValue = (index) => {
    setFormData(prev => ({
      ...prev,
      predefined_values: prev.predefined_values.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // اعتبارسنجی
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = 'عنوان مشخصه الزامی است';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onSubmit(formData);
  };

  const showPredefinedValues = formData.has_predefined_values &&
    (formData.type === 'select' || formData.type === 'color');

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        {/* هدر مودال */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">
            {attribute ? 'ویرایش مشخصه' : 'افزودن مشخصه جدید'}
          </h2>
          <button
            onClick={onCancel}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* بدنه فرم */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {/* عنوان مشخصه */}
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
              عنوان مشخصه *
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                errors.name ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="مثال: وزن"
            />
            {errors.name && <p className="mt-1 text-sm text-red-600">{errors.name}</p>}
          </div>

          {/* توضیحات */}
          <div>
            <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
              توضیحات
            </label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="مثال: وزن جرمی"
            />
          </div>

          {/* واحد اندازه‌گیری */}
          <div>
            <label htmlFor="unit" className="block text-sm font-medium text-gray-700 mb-1">
              واحد اندازه‌گیری
            </label>
            <input
              type="text"
              id="unit"
              name="unit"
              value={formData.unit}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="مثال: کیلوگرم"
            />
          </div>

          {/* نوع مشخصه */}
          <div>
            <label htmlFor="type" className="block text-sm font-medium text-gray-700 mb-1">
              نوع مشخصه
            </label>
            <select
              id="type"
              name="type"
              value={formData.type}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="text">متنی</option>
              <option value="number">عددی</option>
              <option value="color">رنگ</option>
              <option value="select">انتخابی از لیست</option>
              <option value="size">اندازه</option>
            </select>
          </div>

          {/* دارای مقادیر پیشفرض */}
          <div className="flex items-center">
            <input
              type="checkbox"
              id="has_predefined_values"
              name="has_predefined_values"
              checked={formData.has_predefined_values}
              onChange={handleChange}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="has_predefined_values" className="mr-2 block text-sm text-gray-900">
              دارای مقادیر از پیش تعریف‌شده
            </label>
          </div>

          {/* مقادیر پیشفرض */}
          {showPredefinedValues && (
            <div className="border border-gray-200 rounded-lg p-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                مقادیر پیشفرض
              </label>

              {/* افزودن مقدار جدید */}
              <div className="flex gap-2 mb-3">
                <input
                  type="text"
                  value={newValue}
                  onChange={(e) => setNewValue(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), handleAddValue())}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="مقدار جدید"
                />

                <button
                  type="button"
                  onClick={handleAddValue}
                  className="bg-[#1E3A5F] text-[#FFC107] hover:bg-[#2B5388] hover:text-[#D19D00]  px-4 py-2 rounded-lg transition-colors"
                >
                  افزودن
                </button>
              </div>

              {/* لیست مقادیر */}
              <div className="space-y-2">
                {formData.predefined_values.map((item, index) => (
                  <div key={index} className="flex items-center justify-between bg-gray-50 px-3 py-2 rounded">
                    <span className="text-sm text-gray-700">{item.value}</span>
                    <button
                      type="button"
                      onClick={() => handleRemoveValue(index)}
                      className="text-red-600 hover:text-red-800 transition-colors"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* دکمه‌های action */}
          <div className="flex gap-3 pt-4">
            <Button
              variant={'primary'}
              children={attribute ? 'ویرایش' : 'تایید'}
              type="submit"
            />
            <Button
              variant={'secondary'}
              children={'انصراف'}
              onClick={onCancel}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AttributeForm;